import classnames from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { redirectTable } from "../../../utils/helpers";
import "./link-wrapper.scss";

const parseLink = (link, isExternal) => {
  const relProps = link.target === "_blank" ? { rel: "noreferrer noopener" } : null;
  return { [isExternal ? "href" : "to"]: link.url, target: link.target, ...relProps };
};

const LinkWrapper = props => {
  const { link, disabled } = props;

  const classes = classnames("bwl-link-wrapper", {
    "bwl-link-wrapper--disabled": disabled,
  });
  /** Check the type of linksupplied from Umbraco.
   * {internal: 0, media: 1, external: 2}
   * Defaults to external - 2 - if type breaks or is omitted, as we cannot safely render a <Link> unless we know url is
   * internal. */
  let { type = 2 } = link;
  let linky = link;

  // replaces old URLs with new ones based on redirectTable. Needed because we collect the links from Umbraco
  if (link && redirectTable) {
    const match = redirectTable.find(({ pattern }) => {
      if (!pattern) return false;
      try {
        return new RegExp(pattern).test(link.url);
      } catch {
        return false;
      }
    });

    if (match && match.url) {
      type = 2; // redirect links are always external. I hope
      linky = { ...linky, url: match.url };
    }
  }
  const isExternal = type !== 0;

  const Wrapper = disabled ? "div" : isExternal ? "a" : Link;
  const WrapperProps = disabled ? "" : parseLink(linky, isExternal);

  return (
    <Wrapper className={classes} {...WrapperProps}>
      {props.children}
    </Wrapper>
  );
};

LinkWrapper.propTypes = {
  /** The children to wrap */
  children: PropTypes.node,
  /** Boolean prop, disables the link */
  disabled: PropTypes.bool,
  /** The link to be rendered */
  link: PropTypes.shape({
    target: PropTypes.string,
    type: PropTypes.number,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default LinkWrapper;
